import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import { setCurrentPageTitle, setCurrentRoute } from "../store/layoutUI";

export default function LandingPage(props) {
    const usrType = localStorage.getItem("userType");

    const route = [
        { name: "Task Management", url: "" }
    ];
    const route1 = [
        { name: "Contract Management", url: "" }
    ];

    let pageTitle = "";

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentPageTitle("Home"));
        dispatch(setCurrentRoute(route));
    }, [])


    return <React.Fragment>

        <div className="col-md-12 mt-3">
            <span className="">
                Welcome to IPCS's Human Resources, Onboarding and Contract
                Management Portal!
            </span>
            <br />
            <br />
            Click on the items on the left menu and complete the onboarding process
        </div>
    </React.Fragment>

}